/**
 * Created by andrey on 20.02.2026
 *
 * https://yandex.ru/dev/games/doc/ru/sdk/sdk-player
 * Size up to 200kb, 100 queries get+set per 5 minutes.
 * getPlayer - 20 requests per 5 minutes
 *
 * Need to save all data - partial save not supported.
 */

class YandexTransportAdapter {
    constructor() {
        this.config = {
            sendInterval: 10000,
            loadSessionInterval: 30000
        };
    }

    saveData(batch, options, onSuccess, onFailure) {
        batch = SyncTransportUtils.addKeysPrefix("sync_", batch);

        let storedData;

        new ConnectorActionPlayer([
            (f) => {
                if (this.savePlayer) {
                    f();
                    return;
                }

                ysdk.getPlayer({ signed: true }).then((player) => {
                    this.savePlayer = player;
                    f();
                }).catch(onFailure);
            },

            (f) => {
                this.savePlayer.getData().then((data) => {
                    data = { ...data };

                    if (options.syncout) {
                        for (const key in data) {
                            if (key.startsWith("sync_")) {
                                delete data[key];
                            }
                        }
                    }

                    storedData = data;

                    f();
                }).catch(onFailure);
            },

            (f) => {
                const data = { ...storedData, ...batch };

                this.savePlayer.setData(data)
                    .then(f)
                    .catch(onFailure);
            }
        ]).play(onSuccess);
    }

    loadSession(onSuccess, onFailure) {
        this.loadData((data) => onSuccess(data && data.session), onFailure);
    }

    loadData(onSuccess, onFailure) {
        ysdk.getPlayer({ signed: true })
            .then((player) => player.getData())
            .then((data) => {
                data = SyncTransportUtils.removeKeysPrefix("sync_", data);
                onSuccess(data);
            })
            .catch(onFailure);
    }
}
